import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import globalStyles from '../styles/global.module.css';
import styles from './Updates.module.css';
import apiConfig from '../config/api';
import UpdateCard from '../components/UpdateCard';

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const postsPerPage = 10;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(`${apiConfig.baseUrl}${apiConfig.endpoints.updates}`);
        const data = await response.json();
        
        if (data) {
          setPosts(data);
          setTotalPages(Math.ceil(data.length / postsPerPage));
        }
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Pagination component to reuse at top and bottom
  const PaginationControls = () => (
    <div className={styles.pagination}>
      <button
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
        className={styles.pageButton}
      >
        Previous
      </button>
      
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          onClick={() => paginate(i + 1)}
          className={`${styles.pageButton} ${currentPage === i + 1 ? styles.activePage : ''}`}
        >
          {i + 1}
        </button>
      ))}
      
      <button
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={styles.pageButton}
      >
        Next
      </button>
    </div>
  );

  return (
    <Layout>
      <div className={`${globalStyles.pageContainer} ${styles.wideContainer}`}>
        {loading ? (
          <p>Loading posts...</p>
        ) : posts.length === 0 ? (
          <p>No posts yet. The journey hasn't begun!</p>
        ) : (
          <>
            {totalPages > 1 && <PaginationControls />}
            
            <div className={styles.updatesList}>
              {currentPosts.map((post) => (
                <UpdateCard 
                  key={post._id} 
                  post={post} 
                  showDate={true}
                  className={styles.updateCard}
                />
              ))}
            </div>
            
            <PaginationControls />
          </>
        )}
      </div>
    </Layout>
  );
};

export default Posts; 